<template>
  <el-dialog
    :visible.sync="visited"
    title="开通会员"
    width="980px">
    <div>
      <div class="vip-header">
        <el-avatar style="margin: 21px;" :size="91" :src="avatarUrl"></el-avatar>
        <div style="margin-top: 21px">
          <div class="title">{{userInfo.name}}</div>
          <div v-if="!this.vipInfo" class="desc">您还不是会员，开通会员享受权益</div>
          <div v-if="this.vipInfo" class="desc">您已开通会员！
            <span v-if="vipInfo">
            会员到期日：{{vipInfo.vipEdate | dateToStr}}
          </span>
          </div>
        </div>
      </div>
      <el-form :model="paymentInfo" label-width="110px" size="small">
        <div style="margin-top: 20px;display: inline-flex">
          <el-button type="text" :disabled="vipLevels.length<4" class="left-btn" @click="leftLevel">&lt;</el-button>
          <div class="panel-group">
            <div  class="card-panel-col" v-for="(level,index) in vipLevels" :key="level.id" :style="((index === 0)?('margin-left:' + marginLeft + 'px;'):'')">
              <div :class="'card-panel ' + ((paymentInfo.vipId === level.id)?'active-level':'')"
                   @click="handlerSelect(level)">
                <div class="level-name">{{level.name}}</div>
                <div class="price">
                  ¥{{level.price}}
                  <!--<span class="prome-price">({{(level.price * level.month * level.peopleNumber) | convertMoney}})</span>-->
                </div>
                <div class="level-number"><span>{{level.peopleNumber}}</span>人</div>
              </div>
            </div>
          </div>
          <el-button type="text" :disabled="vipLevels.length<4" class="right-btn" @click="rightLevel">&gt;</el-button>
        </div>
        <el-alert
          v-if="alertShow"
          :title="alertMsg"
          style="font-size: 18px;margin-top: 20px;"
          type="warning"
          show-icon>
        </el-alert>
        <el-card style="margin-top: 20px" shadow="never">
        <div style="margin-top: 20px">
          <el-form-item label="付款方式：">
            <el-radio-group v-model="paymentInfo.payType" size="small">
              <el-radio border v-for="(item) in commonUtils.getDictPara('pay_type')" :key="item.code" :label="item.code">
                {{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div style="margin-top: 20px;">
          <el-form-item label="是否开票：">
            <el-radio-group v-model="paymentInfo.invoiceType" size="small" @change="channgeInvoiceType">
              <el-radio border v-for="(item) in commonUtils.getDictPara('invoice_type')" :key="item.code"
                        :label="item.code">{{item.name}}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="paymentInfo.invoiceType !== '1'" label="发票抬头：">
            <el-button plain @click="showInvoiceSel = true">更换发票抬头</el-button>
          </el-form-item>
          <el-dialog
            title="选择发票抬头"
            :visible.sync="showInvoiceSel"
            :destroy-on-close="true"
            width="50%">
            <select-invoice ref="selInvoice"></select-invoice>
            <span slot="footer" class="dialog-footer">
                  <el-button @click="showInvoiceSel = false">取 消</el-button>
                  <el-button type="primary" @click="handleInvoiceAddress">确 定</el-button>
                </span>
          </el-dialog>
          <el-row v-if="paymentInfo.invoiceType !== '1'" style="width: 80%">
            <el-col :span="12">
              <el-form-item label="名称：">
                {{paymentInfo.invoiceName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纳税人识别号：">
                {{paymentInfo.invoiceTaxNumber}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地址：">
                {{paymentInfo.invoiceAddress}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电话：">
                {{paymentInfo.invoicePhone}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行：">
                {{paymentInfo.invoiceBankName}}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行账号：">
                {{paymentInfo.invoiceBankNo}}
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="应付金额：">
            <span class="price">{{totalPrice | convertMoney}}<span class="unit">元</span></span>
          </el-form-item>
          <div style="margin-left: 30px;position: relative;">
            <el-checkbox v-model="readFlag">我接受许可协议中的条款</el-checkbox>
            <span style="margin-left:10px;position: relative; top: -2px;"><el-link type="warning" @click="vipMsgVisible = true">阅读</el-link></span>
          </div>
        </div>
        <div class="div-pay">
          <el-button type="warning" @click="handleSubmit">提交付款</el-button>
        </div>
        </el-card>
      </el-form>
      <el-card style="margin-top: 20px" shadow="never">
      <h2>会员权益</h2>
      <div class="rights-list">
        <div class="rights-item" v-for="item in vipRights" :key="item.id">
          <img :src="item.imgUrl"/>
          <div style="margin-left: 10px;">
            <span class="rights-title">{{item.title}}</span>
            <br/>
            <span class="rights-desc">{{item.description}}</span>
          </div>
        </div>
        <el-button v-if="vipRightsAll.length>vipRightsAllNum" type="text" style="width: 100%;font-size: 16px;font-weight: 400;color: #999999;" @click="viewMore">{{brandFold?'查看更多':'收起'}}</el-button>
      </div>
      </el-card>
    </div>
    <el-dialog title="支付订单" :visible.sync="payOrderVisible" v-if="payOrderVisible" :destroy-on-close="true"
               width="40%" center
               :close-on-click-modal="false"
               :close-on-press-escape="false" append-to-body>
      <pay-order ref="payOrderDialog" v-if="payOrderVisible"  :orderId = "orderId" :payType = "paymentInfo.payType" @submitpay="submitPay" :sendMsg="sendMsg"></pay-order>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payOrderVisible = false">取 消</el-button>
        <el-button v-if="paymentInfo.payType === '2'" type="primary" @click="submitPay">提 交</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="vipMsgVisible" :destroy-on-close="true"
               width="60%" center
               :close-on-click-modal="true"
               :close-on-press-escape="false" append-to-body>
      <vip-msg ref="vipMsgDialog" ></vip-msg>
      <span slot="footer" class="dialog-footer">
        <el-button @click="vipMsgVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getLists } from '@/api/user/memberPrice'
import { openVip, saveTransfer } from '@/api/user/userVip'
import { getLists as adsPicList } from '@/api/ads/adsPics'
import SelectInvoice from '../entrust/sub-page/select-invoice'
import { list as invoiceList } from '@/api/user/userInvoice'

export default {
  components: { SelectInvoice },
  data () {
    return {
      primePrice: 20,
      totalPrice: 0,
      payOrderVisible: false,
      showInvoiceSel: false,
      alertShow: false,
      sendMsg: '',
      vipMsgVisible: false,
      readFlag: true,
      alertMsg: '',
      marginLeft: 0,
      vipAdsImg: {},
      orderId: '',
      vipLevels: [],
      vipRights: [],
      vipRightsAll: [],
      vipRightsAllNum: 9,
      invoice: {
        invoiceAddress: '',
        invoiceBankName: '',
        invoiceBankNo: '',
        invoiceName: '',
        invoicePhone: '',
        invoiceTaxNumber: ''
      },
      paymentInfo: {
        vipId: '',
        invoiceType: '1',
        payType: '0',
        invoiceAddress: '',
        invoiceBankName: '',
        invoiceBankNo: '',
        invoiceName: '',
        invoicePhone: '',
        invoiceTaxNumber: ''
      },
      avatarUrl: 'http://darihua-public.oss-cn-shenzhen.aliyuncs.com/null/rech_text/DocFile/20201121/5fb9255300873134f521fc76.png',
      visited: false,
      payClose: null
    }
  },
  mounted () {
    this.getLists()
    this.vipPicList()
  },
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo
    },
    vipInfo () {
      return this.$store.state.user.vipInfo
    }
  },
  methods: {
    show () {
      this.visited = true
    },
    handlerSelect (item) {
      if (this.vipInfo) {
        var date = new Date(this.vipInfo.vipEdate)
        if (item.peopleNumber === 1) {
          this.alertShow = true
          var d = date.setMonth(date.getMonth() + item.month)
          this.alertMsg = '您已经成为会员，再次购买，将您的会员过期日期延长至' + this.getStrDate(d)
          this.sendMsg = '会员将延长至' + this.getStrDate(d)
        } else {
          this.alertShow = true
          this.alertMsg = '您已经成为会员，再次购买，您将拥有' + (item.peopleNumber) + '个可分配会员'
          this.sendMsg = '您将拥有' + (item.peopleNumber) + '个可分配会员'
        }
      } else {
        if (item.peopleNumber > 1) {
          this.alertShow = true
          this.alertMsg = '购买该会员后，您将成为会员，同时有' + (item.peopleNumber - 1) + '个可分配会员'
          this.sendMsg = '将成为会员，并拥有' + (item.peopleNumber - 1) + '个可分配会员'
        } else {
          this.alertShow = false
          this.sendMsg = item.name
        }
      }
      this.paymentInfo.vipId = item.id
      this.totalPrice = item.price
    },
    getStrDate (date) {
      if (date !== null) {
        var strData = new Date(date)
        var month = strData.getMonth() + 1
        var day = strData.getDate()

        if (month < 10) {
          month = '0' + month
        }
        if (day < 10) {
          day = '0' + day
        }
        return strData.getFullYear() + '-' + month + '-' + day
      }
    },
    channgeInvoiceType () {
      if (!this.paymentInfo.invoiceName) {
        let param = {}
        param.page = {
          pageNum: 1,
          pageSize: 1
        }
        invoiceList(param).then(res => {
          var result = res.data
          if (result.rtnCode !== '0') {
            this.$message({
              type: 'info',
              message: result.msg
            })
          } else {
            if (result.bizData && result.bizData.length > 0) {
              this.paymentInfo.invoiceAddress = result.bizData[0].address
              this.paymentInfo.invoiceBankName = result.bizData[0].bank
              this.paymentInfo.invoiceBankNo = result.bizData[0].bankAccount
              this.paymentInfo.invoiceName = result.bizData[0].title
              this.paymentInfo.invoicePhone = result.bizData[0].mobile
              this.paymentInfo.invoiceTaxNumber = result.bizData[0].taxNumber
            }
          }
        }).catch(ex => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
      }
    },
    handleSubmit () {
      if (!this.readFlag) {
        this.$message.info('请勾选许可协议')
        return
      }
      openVip(this.paymentInfo).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.orderId = result.bizData
          this.payOrderVisible = true
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('提交失败，请稍后再试！')
      })
    },
    submitSuccessPay () {
      this.$router.go(0)
    },
    leftLevel () {
      if (this.marginLeft < 0 && this.vipLevels.length > 3) {
        this.marginLeft = this.marginLeft + 284
      }
    },
    rightLevel () {
      let max = 0 - (this.vipLevels.length - 1) * 284
      if (this.marginLeft > max && this.vipLevels.length > 3) {
        this.marginLeft = this.marginLeft - 284
      }
    },
    viewMore () {
      if (this.brandFold) {
        this.vipRights = this.vipRightsAll
        this.brandFold = false
      } else {
        this.vipRights = this.vipRightsAll.slice(0, this.vipRightsAllNum)
        this.brandFold = true
      }
    },
    vipPicList () {
      let param = {}
      param.categoryCode = 'vip_rights'
      adsPicList(param).then(res => {
        this.loading = false
        var result = res.data
        if (result.rtnCode !== '0') {
          this.$message({
            type: 'info',
            message: result.msg
          })
        } else {
          this.vipRightsAll = result.bizData
          this.vipRights = result.bizData.slice(0, this.vipRightsAllNum)
        }
      }).catch(ex => {
        this.loading = false
        this.$message.error('列表加载失败，请稍后再试！')
      })
    },
    getLists () {
      getLists().then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          this.vipLevels = result.bizData
          this.paymentInfo.vipId = this.vipLevels[0].id
          this.totalPrice = this.vipLevels[0].price
          this.handlerSelect(this.vipLevels[0])
        } else {
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.$message.error('加载失败')
      })
    },
    handleInvoiceAddress () {
      this.showInvoiceSel = false
      this.paymentInfo.invoiceAddress = this.$refs['selInvoice'].selectInvoice.invoiceAddress
      this.paymentInfo.invoiceBankName = this.$refs['selInvoice'].selectInvoice.invoiceBankName
      this.paymentInfo.invoiceBankNo = this.$refs['selInvoice'].selectInvoice.invoiceBankNo
      this.paymentInfo.invoiceName = this.$refs['selInvoice'].selectInvoice.invoiceName
      this.paymentInfo.invoicePhone = this.$refs['selInvoice'].selectInvoice.invoicePhone
      this.paymentInfo.invoiceTaxNumber = this.$refs['selInvoice'].selectInvoice.invoiceTaxNumber
    },
    submitPay () {
      if (this.paymentInfo.payType === '2') {
        let param = {}
        param.imgUrl = this.$refs['payOrderDialog'].filePath
        if (!param.imgUrl) {
          this.$message.warning('请上传支付凭证！')
          return false
        }
        param.orderId = this.orderId
        saveTransfer(param).then(res => {
          var result = res.data
          if (result.rtnCode === '0') {
            this.$message.success('提交成功！')
            this.visited = false
            this.payOrderVisible = false
            this.$message.warning('转账审核通过后可以访问！，您可以进入我的账单查看审核结果。')
          } else {
            this.$message.error(result.bizMsg)
          }
        }).catch(() => {
          this.$message.error('加载失败')
        })
      } else {
        this.visited = false
        this.payOrderVisible = false
        // TODO 暂且改成刷新页面
        // this.$router.go(0)
        if (this.payClose) {
          this.$store.dispatch('getSysInfo').then(user => {
            this.visited = false
          })
        } else {
          this.$store.dispatch('getSysInfo').then(user => {
            let paramx = null
            if (this.$router.history.pending) {
              paramx = this.$router.history.pending
              this.$router.push({ path: paramx.path, query: paramx.query })
            } else {
              paramx = this.$router.history.current
              this.$router.go(0)
            }
            // this.$router.push({ path: this.$router.history.pending.path, query: this.$router.history.pending.query })
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .el-alert__title{
    font-size: 18px;
  }
  .vip-header{
    height: 132px;
    background: #F9E2B0;
    display: inline-flex;
    width: 100%;
    border-radius: 6px 6px 0px 0px;
    .title{
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      margin-top: 15px;
    }
    .desc{
      font-size: 18px;
      font-weight: 400;
      color: #666666;
      margin-top: 10px;
    }
  }
  .panel-group {
    display: inline-flex;
    width: 851px;
    overflow: hidden;
    margin: 0 10px;
    .active-level {
      background: #FCF7E6!important;
      border: 2px solid #EBC96A!important;
    }
    .card-panel {
      width: 260px;
      height: 150px;
      cursor: pointer;
      margin: 0 10px;
      font-size: 12px;
      position: relative;
      overflow: hidden;
      background: #FFFFFF;
      border: 2px solid #E7E7E7;
      border-radius: 8px;
      &:hover {
        background: #FCF7E6!important;
        border: 2px solid #EBC96A!important;
      }
      .level-name {
        font-size: 22px;
        font-weight: bold;
        color: #333333;
        margin-top: 15px;
        text-align: center;
      }
      .level-number {
        font-size: 20px;
        font-weight: 500;
        color: #999999;
        margin-top: 15px;
        text-align: center;
      }
    }
  }

  .price {
    text-align: center;
    margin-top: 15px;
    font-size: 26px;
    font-weight: 800;
    color: #FFD069;
  }
  .left-btn,.right-btn{
    width: 30px;
    text-align: center;
    cursor: pointer;
    color: #FFD069;
    font-weight: bold;
    &:hover {
      background: #FCF7E6!important;
    }
  }
  .prome-price {
    font-size: 12px;
    color: #3e3e3e;
    margin: 5px;
    text-decoration: line-through;
  }

  .unit {
    font-size: 20px;
    color: #3e3e3e;
    margin-left: 10px;
  }

  .div-pay {
    text-align: center;
    button {
      margin-left: 20px;
    }
  }
  .rights-list {
    width: 100%;
    padding: 0px 70px;
    margin-top: 56px;
    .rights-item {
      float: left;
      width: 280px;
      display: inline-flex;
      vertical-align: middle;
      background-color: #ffffff;
      margin: 16px 5px;
      margin-bottom: 60px;
      img {
        height: 60px;
        width: 60px;
        vertical-align: middle;
      }
      .rights-title {
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        width: 140px;
        margin-top: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .rights-desc{
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        margin-top: 5px;
        width: 140px;
        line-height: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>
